import anonymousTracker from './anonymous';
import authedTracker from './authed';
import publicTracker from './public';
import type { MultiTracker, TrackerType } from '../types';

export const trackerMap: Record<TrackerType, MultiTracker> = {
  anonymous: anonymousTracker,
  authed: authedTracker,
  public: publicTracker,
};
